<template>
    <div class="wrapper">
        <app-header></app-header>
        <!-- preloader -->
        <div class="preloader" v-if="isLoading">
            <div class="spinner spinner-1"></div>
        </div>
        <!-- /preloader -->
        <router-view></router-view>
        <app-footer></app-footer>
    </div>
</template>

<script>
/*eslint-disable */
import { initAuthListener } from '@/utils/authChannel';

import footer from '@/components/common/footer/index.vue';
import header from '@/components/common/header/index.vue';

export default {
    name: 'app',
    components: {
        'app-header': header,
        'app-footer': footer,
    },
    props: [],
    computed: {
        isLoading() {
            return this.$store.state.loader.loading || false
        }
    },
    mounted() {
        // Starts listening for the logout signal from other tabs right when the app loads
        initAuthListener();
    }
}

</script>

<style lang="scss">
@import url("../assets/font-awesome/css/font-awesome.min.css");
@import url("../assets/fonts/AlienAndroid/styles.css");
@import url("../assets/fonts/blogHeading/stylesheet.css");
@import url("../assets/fonts/georgia/stylesheet.css");
@import url("../assets/fonts/AceSansDemo/styles.css");
@import url("../assets/fonts/beon/styles.css");
@import url('https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700;800&display=swap');
@import url("https://fonts.googleapis.com/css?family=Lato:100,100i,300,300i,400,400i,700,700i,900,900i");
@import url("../assets/css/video.scss");

@font-face {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    src: url("../assets/fonts/sylfaen/Sylfaen.eot?#iefix") format("embedded-opentype"), url("../assets/fonts/sylfaen/Sylfaen.woff") format("woff"), url("../assets/fonts/sylfaen/Sylfaen.ttf") format("truetype"), url("../assets/fonts/sylfaen/Sylfaen.svg#Sylfaen") format("svg");
    font-weight: normal;
    font-style: normal;
}

body {
    margin: 0 !important;
    font-family: 'BeonMedium', sans-serif !important;
    font-size: 14px !important;
    color: #9b9b9b !important;
    line-height: 1.3 !important;
    background: #000 !important
}

ul {
    margin: 0;
    padding: 0;
    list-style: none
}

ul.login_btn {
    margin-bottom: 0
}

a,
a:hover {
    text-decoration: none
}

.font_large {
    font-size: 70px;
    line-height: 45px
}

.header_fix {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 999
}

.header_fix .navbar {
    padding: 10px 15px
}

.navbar-brand .img-fluid {
    max-width: 270px
}

.navbar-brand {
    color: #fff;
    text-decoration: none;
    transition: all .3s ease-in;
    transform-origin: left center;
    -webkit-transform-origin: left center;
    transform: scale(1);
    -webkit-transform: scale(1)
}


.login_btn li .btn-default.planet_img img {
    width: 37px
}

.login_btn li {
    display: inline-block;
    vertical-align: middle;
    margin-right: 21px
}

.login_btn li:last-child {
    margin-right: 0
}

.login_btn li .btn-default {
    line-height: 34px;
    background: rgba(255, 255, 255, 0.07);
    color: #fff;
    font-size: 16px;
    padding: 0 20px;
    transition: all ease .5s;
    -webkit-transition: all ease .5s;
    -moz-transition: all ease .5s;
    box-shadow: none;
    outline: 0;
    min-width: 115px;
    font-weight: 400
}

.login_btn li .btn-default.Q_btn {
    font-size: 30px
}

.login_btn li .btn-default .img-fluid {
    width: 45px
}

.hover_img {
    display: none
}

.login_btn li .btn-default:hover .hover_img {
    display: inline-block
}

.login_btn li .btn-default:hover .normal_img {
    display: none
}

.login_btn li .btn-default:hover {
    background: #87cefa;
    color: #000;
    font-weight: 700
}

.section {
    height: 100dvh;
    background-size: cover;
    background-position: top center;
    position: relative;
    background-repeat: no-repeat
}

.home_welcome {
    background-color: #000;
    background-size: 100% 100%;
    overflow: hidden
}

.welcome_popup {
    position: relative;
    right: -120%;
    transition: all ease .7s
}

.welcome_popup.active {
    right: 0
}

.home_welcome .container {
    padding-top: 67px;
    max-width: 98%
}

.section .container {
    display: table;
    width: 100%;
    height: 100%
}

.center_content {
    display: table-cell;
    vertical-align: middle
}

.light_bg_section {
    background: rgba(0, 0, 0, 0.7);
    padding: 0
}

.section_heading {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    color: #fff;
    line-height: 1.5;
    font-weight: 400;
    text-align: left;
    font-size: 25px;

    @media only screen and (max-width:767px) {
        font-size: 18px;
    }
}

.section_heading span {
    font-family: 'BeonMedium', sans-serif;
    font-size: 34px;
    color: #ffc107;

    @media only screen and (max-width:767px) {
        font-size: 24px;
    }
}

.lymphomap_about .section_heading span,
.welcome_popup_wrp .section_heading span {
    color: #d29e00
}

.section_heading span.popup_main_title_lymphomap {
    color: #87cefa;
    font-size: 26px;

    @media only screen and (max-width:767px) {
        font-size: 18px;
    }
}

.welcome_popup .light_bg_section {
    height: calc(100dvh - 115px)
}

.welcome_popup_wrp .section_heading {
    font-size: 30px;
    text-align: justify;
    color: #d6d6d6
}

.welcome_popup .section_heading {
    max-width: 1240px;
    margin: 0 auto 12px
}

.welcome_section {
    padding: 10px;
    text-align: left;
    background: #000;
    min-height: 100dvh;
    position: relative;
    overflow: hidden
}

.welcome_top_layers .img-fluid,
.welcome_btm_layers .img-fluid {
    max-width: 70%;
    height: 100%
}

.welcome_btm_layers {
    text-align: right;
    margin-top: 15px;
    padding-right: 20px
}

.welcome_logo .img-fluid {
    max-width: 580px;
    transition: all .8s ease;
    -webkit-transition: all .8s ease;
    transform: scale(1);
    -webkit-transform: scale(1);
    transform-origin: center center;
    -webkit-transform-origin: center center
}

.welcome_logo_text:hover+.welcome_logo .img-fluid {
    transform: scale(1.1);
    -webkit-transform: scale(1.1)
}

.welcome_logo {
    display: block;
    text-align: center
}

.welcome_logo_btm_text .img-fluid {
    max-width: 455px
}

.welcome_top_layers {
    padding-left: 20px
}

.welcome_logo_btm_text {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center
}

.welcome_center_layers {
    position: relative;
    top: -30px;
    margin-bottom: -30px;
    height: 160px;
    opacity: 1
}

.welcome_logo_inner {
    display: inline-block;
    position: relative
}

.welcome_logo_wrp {
    text-align: center
}

.welcome_logo_text {
    max-width: 439px;
    height: 70px;
    display: inline-block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
    margin: 0 auto;
    border-radius: 10px;
    cursor: pointer;
    z-index: 100
}

.header_show .header_fix {
    opacity: 1;
    visibility: visible
}

.learn_more_btn {
    display: inline-block;
    background: #640000;
    text-decoration: none;
    font-size: 16px;
    text-align: center;
    padding: 8px 30px;
    font-family: Arial, Helvetica, sans-serif;
    text-transform: uppercase;
    color: #fff;
    transition: all ease .5s;
    -webkit-transition: all ease .5s;
    -moz-transition: all ease .5s
}

.learn_more_btn:hover {
    background: #fff;
    color: #000
}

.l_btn_wrp {
    text-align: center;
    padding-top: 50px
}

.footer-copy {
    color: #fff;
    font-size: 15px;
    font-weight: 400;
    margin-top: 5px
}

.preloader {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: #fefefe;
    z-index: 100000;
    min-height: 100dvh;
}

.loader {
    width: 120px;
    height: 120px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -60px 0 0 -60px;
    font-size: 10px;
    text-indent: -12345px;
    border-top: 1px solid #eee;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #333;
    border-left: 1px solid #333;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-animation: spinner 500ms infinite linear;
    -moz-animation: spinner 500ms infinite linear;
    -ms-animation: spinner 500ms infinite linear;
    -o-animation: spinner 500ms infinite linear;
    animation: spinner 500ms infinite linear;
    z-index: 100001
}

@-webkit-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg)
    }
}

@-moz-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg)
    }
}

@-o-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg)
    }
}

@keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg)
    }
}

.welcome_top_layers,
.welcome_btm_layers {
    height: calc(50vh - 80px)
}

.welcome_logo_btm_text_inner {
    position: relative;
    min-width: 480px;
    display: inline-block
}

.white_cursor {
    width: 20px;
    position: absolute;
    right: -75px;
    top: 100%
}

.typewrite {
    color: green;
    font-family: 'binchrt';
    text-transform: uppercase;
    font-size: 26px;
    margin: 0;
    line-height: 22px
}

.typewrite .wrap {
    line-height: 12px;
    display: inline-block;
    vertical-align: middle;
    margin: auto;
    min-height: 16px;
    word-spacing: -10px;
    letter-spacing: 1px
}

.ab_main_popup {
    position: absolute;
    top: 0;
    right: -220%;
    display: flex;
    height: 100dvh;
    padding-top: 62px;
    transition: all ease .7s;
    -webkit-transition: all ease .7s;
    width: 100%;
    z-index: 10001
}

.active_popup .welcome_center_layers {
    opacity: 0
}

.ab_main_popup.active {
    right: 0
}

.ab_main_popup .light_bg_popup {
    background: rgba(0, 0, 0, 0.9);
    padding: 15px 25px;
    height: calc(100dvh - 160px);
    display: flex;
    align-items: center;
    max-width: 1080px;
    margin: auto;
    position: relative;
    z-index: 10000;
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.045)
}

.lymphomap_computer_data.ab_main_popup .light_bg_popup {
    height: calc(100dvh - 80px);
    max-width: 1000px
}

.wrapper {
    overflow: hidden;
    position: relative
}

@media only screen and (max-width: 1350px) {
    .login_btn li .btn-default {
        font-size: 14px;
        padding: 3px 15px
    }

    .login_btn li .btn-default .img-fluid {
        width: 38px
    }

    .login_btn li .btn-default.planet_img img {
        width: 30px
    }
}

@media screen and (max-width: 768px) {
    .spinner {
        width: 80px;
        height: 80px
    }
}

@media screen and (max-width: 738px) {
    .spinner {
        width: 70px;
        height: 70px
    }
}

@media screen and (max-width: 414px) {
    .spinner {
        width: 60px;
        height: 60px
    }
}

.fixloader {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.72);
    width: 100%;
    z-index: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center
}

.spinner {
    position: relative;
    width: 125px;
    height: 125px;
    margin: 30px auto
}

.spinner:before,
.spinner:after {
    content: "";
    display: block;
    position: absolute;
    border-width: 4px;
    border-style: solid;
    border-radius: 50%
}

@-webkit-keyframes rotate-animation {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg)
    }
}

@keyframes rotate-animation {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg)
    }
}

@-webkit-keyframes anti-rotate-animation {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(-360deg);
        transform: rotate(-360deg)
    }
}

@keyframes anti-rotate-animation {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg)
    }

    100% {
        -webkit-transform: rotate(-360deg);
        transform: rotate(-360deg)
    }
}

.spinner.spinner-1:before {
    width: 117px;
    height: 117px;
    top: 0;
    left: 0;
    -webkit-animation: rotate-animation 1s linear 0s infinite;
    animation: rotate-animation 1s linear 0s infinite
}

.spinner.spinner-1:after {
    width: 81.9px;
    height: 81.9px;
    top: 17.55px;
    left: 17.55px;
    -webkit-animation: anti-rotate-animation .85s linear 0s infinite;
    animation: anti-rotate-animation .85s linear 0s infinite
}

.spinner.spinner-1:before {
    border-color: rgba(255, 0, 0, 0) #3498db #3498db rgba(255, 0, 0, 0)
}

.spinner.spinner-1:after {
    border-color: rgba(255, 0, 0, 0) #e74c3c #e74c3c rgba(255, 0, 0, 0)
}


.profile-dob .mx-datepicker {
    display: block;
    width: 180px
}

.profile-dob .mx-calendar-icon {
    color: #fff
}

.profile-dob .mx-input-icon {
    color: #fff
}

.profile-dob .mx-input {
    padding: .375rem .75rem;
    background: rgba(201, 219, 220, 0.5) !important;
    border-color: transparent;
    font-size: 15px;
    color: #fff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    -webkit-transition: all cubic-bezier(0.42, 1.14, 1, 1) .7s;
    transition: all cubic-bezier(0.42, 1.14, 1, 1) .7s;
    height: 38px;
    border-radius: .25rem;
    border: none
}

.profile-dob .mx-icon-calendar,
.profile-dob .mx-icon-clear {
    color: #fff !important
}

.profile-dob .mx-input:focus {
    color: #fff;
    background-color: #fff;
    border: none;
    outline: 0;
    -webkit-box-shadow: 0 0 0 .2rem rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 .2rem rgba(0, 123, 255, 0.25)
}

.profile-dob .mx-input:focus~.mx-calendar-icon,
.profile-dob .mx-input:focus~.mx-input-icon {
    color: #000
}

body.task_modal_actv {
    overflow: hidden
}

body.dashboard::after,
body.public_page_for_wrp_img::after {
    content: "";
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(../assets/images/lymphomap-landing-blank.jpg) 50% #222423;
    background-size: cover;
    background-repeat: no-repeat
}

body.dashboard::before,
body.public_page_for_wrp_img::before {
    content: "";
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(../assets/images/slide_img.png);
    background-repeat: no-repeat;
    z-index: 2;
    background-size: 77.6%;
    right: 0;
    background-position: center center;
    opacity: .6
}

body.dashboard .wrapper,
body.public_page_for_wrp_img .wrapper {
    z-index: 10
}

body .back_btn {
    border-radius: 35px;
    padding: 0;
    margin-right: 10px;
    font-size: 16px;
    display: inline-block;
    vertical-align: text-bottom;
    line-height: 32px;
    width: 32px;
    height: 32px;
    outline: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background: rgba(255, 255, 255, 0.1);
    color: #fff
}

body .back_btn:hover {
    background: #87cefa;
    color: #000
}

select.form-control {
    -moz-appearance: none
}


body.showoverlay {
    overflow: hidden
}

body.showoverlay .modal {
    position: fixed;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.7);
    justify-content: center;
    align-items: center;
    padding: 30px 15px;
    overflow: auto !important;
    height: 100dvh;
    display: none
}

body.showoverlay .modal.show {
    display: flex;
    display: -webkit-flex
}

body.showoverlay .modal .modalbox {
    width: 100%;
    background: #000;
    border-radius: 10px;
    display: block;
    position: relative;
    height: auto;
    color: #fff;
    font-size: 15px;
    box-shadow: 3px 3px 3px rgba(255, 255, 255, 0.04), -3px -3px 3px rgba(255, 255, 255, 0.04);
    -webkit-box-shadow: 3px 3px 3px rgba(255, 255, 255, 0.04), -3px -3px 3px rgba(255, 255, 255, 0.04)
}

body.showoverlay .modal .modalbox .modal-header {
    position: relative;
    font-size: 22px;
    border-radius: 10px 10px 0 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    display: -webkit-flex;
    align-items: center;
    padding: 15px 45px 15px 17px;
    color: #fff;
    text-transform: none;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    font-weight: 500
}

body.showoverlay .modal .modalbox .modal-header .btn-close {
    background: none;
    border: none;
    width: 28px;
    position: absolute;
    right: 10px;
    top: 14px
}

body.showoverlay .modal .modalbox .modal-header .btn-close .fa {
    font-size: 20px;
    color: red
}

body.showoverlay .modal .modalbox .modal-header .btn-close:focus {
    outline: none;
    box-shadow: none
}

body.showoverlay .modal .modalbox .modal-body {
    padding: 30px
}

body.showoverlay .modal .modalbox .modal-body h1,
body.showoverlay .modal .modalbox .modal-body h2,
body.showoverlay .modal .modalbox .modal-body h3,
body.showoverlay .modal .modalbox .modal-body h4,
body.showoverlay .modal .modalbox .modal-body h5,
body.showoverlay .modal .modalbox .modal-body h6 {
    color: #222423;
    letter-spacing: .02em
}

body.showoverlay .modal .modalbox .modal-body .form-control {
    background: rgba(0, 0, 0, 0.9);
    color: #fff
}

.covid_19_popup.popup_actv {
    height: 100dvh !important;
    width: 100vw !important;
    left: 0 !important;
    bottom: 0 !important;
    padding: 12px !important;
    border-width: 4px !important
}

.covid_19_popup.popup_actv .covid_19_popup_expand_btn {
    display: block !important
}

.covid_19_popup_actv .lymphomap_auth_main {
    opacity: 0
}

.covid_19_popup_actv header.header_fix {
    opacity: 0;
    display: none
}

.covid_19_popup_actv {
    overflow: hidden !important
}

.covid_19_popup_actv .covid_19_popup .covid_19_popup_inner .covid_19_popup_center_conten {
    vertical-align: top !important
}

.covid_19_popup_actv .covid_19_popup .covid_19_popup_inner {
    padding: 15px !important
}

.chart_wrp .chartjs-render-monitor {
    height: calc(100dvh - 330px) !important
}

.graph_wrp {
    height: calc(100dvh - 285px) !important;
    overflow: hidden
}

.chart_graph_popup .MJXc-display,
.data_search_form .MJXc-display {
    display: inline-block;
    outline: none;
    cursor: none;
    margin: 0
}

.syntax_highlighter_wrp pre code {
    width: 100%;
    border: 1px solid grey;
    height: 380px;
    font-size: 14px
}

.covid_popup_disabled.covid_19_popup,
.covid_popup_disabled .covid_19_popup,
.popup_actv .covid_19_popup {
    opacity: .09
}

.covid_popup_disabled .more_info_add {
    display: none
}


.lymphomap_about.ab_main_popup .light_bg_popup,
.welcome_popup_wrp.ab_main_popup .light_bg_popup {
    height: calc(100dvh - 80px);
    overflow-y: auto;
    max-width: 1000px;
    display: block;
    width: 100%
}

.lymphomap_about.ab_main_popup .light_bg_popup::-webkit-scrollbar,
.welcome_popup_wrp.ab_main_popup .light_bg_popup::-webkit-scrollbar {
    width: 0;
    background: transparent;
    border-radius: 2px
}

.lymphomap_about.ab_main_popup .light_bg_popup::-webkit-scrollbar-thumb,
.welcome_popup_wrp.ab_main_popup .light_bg_popup::-webkit-scrollbar-thumb {
    background-color: #000
}

.lymphomap_about.ab_main_popup .light_bg_popup .welcome_popup_inner,
.welcome_popup_wrp.ab_main_popup .light_bg_popup .welcome_popup_inner {
    display: table;
    height: calc(100dvh - 110px);
    width: 100%
}

.lymphomap_about.ab_main_popup .light_bg_popup .welcome_popup_inner .ab_content_center,
.welcome_popup_wrp.ab_main_popup .light_bg_popup .welcome_popup_inner .ab_content_center {
    display: table-cell;
    vertical-align: middle
}

.dashboard.mobileNoupdatePopup {
    overflow-y: hidden
}

@media only screen and (max-width: 767px) {
    .mbl_none {
        display: none !important
    }
}

@media only screen and (min-width: 767px) {
    .desktop_none {
        display: none !important
    }
}

@media only screen and (min-width: 1023px) {
    .only_desktop_none {
        display: none !important
    }
}

@media only screen and (max-width: 1023px) {
    .ipad_none {
        display: none !important
    }
}

body.videoNotificationPopup {
    overflow-y: hidden
}

.hyper_link {
    color: #18027e !important;
    text-decoration: none !important
}

.vue-tel-input.custom_mobile_number {
    position: relative
}

.vue-tel-input.custom_mobile_number .invalid-feedback {
    display: block;
    position: absolute;
    bottom: -23px;
    font-size: 13px;
    font-weight: 600
}

.video_dashboard_wrp .video_toolbar_with_prfl_img.video_toolbar_for_self>.container {
    max-width: 360px !important
}

.video_dashboard_wrp .video_toolbar_with_prfl_img.video_toolbar_for_self .video_toolbar_list li .img-fluid {
    width: 30px !important
}

.video_dashboard_wrp .video_toolbar_with_prfl_img.video_toolbar_for_self .video_toolbar_list li.end_call_btn .btn {
    font-size: 16px
}

.video_dashboard_wrp .video_toolbar_with_prfl_img.video_toolbar_for_self .video_toolbar_list li.end_call_btn {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 115px;
    flex: 0 0 135px;
    max-width: 135px
}

body.notConnectedUserBody {
    overflow-y: hidden
}

.lymphomap_auth .login_form_inner .form-control[aria-invalid="true"]+.email_mbl_error {
    display: block !important
}

.show_login_user_label_wrp.no_active {
    opacity: .5
}

body.registration_form .oncology_well_form .sign_up_btn {
    display: none !important
}

body.registration_form .oncology_well_form .more_info_add_btn {
    display: none !important
}

.acknowledgement_popup_show {
    overflow-y: hidden
}

.presentation_view {
    overflow-y: hidden
}

.presentation_view header {
    display: none !important
}

.presentation_view footer {
    display: none !important
}

.presentation_view .ab_main_popup {
    display: none !important
}

body.user_agreement_popup {
    overflow-y: hidden
}

.user_filter_label {
    letter-spacing: 0
}

.user_filter_label .dropdown .form_control {
    padding: 0 25px 0 5px !important;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.1) !important;
    background-image: url(../assets/images/down_arrow.png);
    background-position: center right 4px;
    background-repeat: no-repeat;
    background-size: 12px;
    transition: all .7s cubic-bezier(0.42, 1.14, 1, 1);
    min-width: 121px;
    border-radius: 4px;
    font-size: 16px;
    color: #fff;
    line-height: 36px;
    height: 36px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif
}

.user_filter_label .dropdown-menu {
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
    border: none
}

.user_filter_label .dropdown-menu .dropdown-menuin ul {
    margin: 0;
    padding: 0
}

.user_filter_label .dropdown-menu .dropdown-menuin ul li {
    padding: 3px 5px;
    cursor: pointer;
    background: none !important;
    border: none !important;
    color: #ffc107;
    font-size: 18px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif
}

.user_filter_label .dropdown-menu .dropdown-menuin ul li:hover {
    background: #2b76ff !important;
    color: #fff
}

.height_increased.user_filter_label .dropdown .form_control {
    height: 40px;
    line-height: 40px
}

.signup_form .height_increased.user_filter_label .dropdown .form_control {
    height: 50px;
    line-height: 50px;
    min-width: 137px
}

.signup_form .height_increased.user_filter_label .dropdown .form_control:focus {
    box-shadow: 0 0 0 .2rem rgba(0, 123, 255, 0.25)
}

.signup_form .user_filter_label .dropdown .form_control {
    font-size: 20px
}

.multiselect .multiselect__tags {
    border: none;
    background: rgba(255, 255, 255, 0.1) !important;
    font-size: 16px;
    padding: 9px 40px 0 9px;
    min-height: 45px;
    border-radius: 4px
}

.multiselect__input,
.multiselect__single {
    background: none !important;
    color: #fff;
    margin: 0 !important;
    padding: 0 !important
}

.multiselect__input::-webkit-input-placeholder {
    color: #fff !important
}

.multiselect__input::-moz-placeholder {
    color: #fff !important
}

.multiselect .multiselect__placeholder {
    color: #fff;
    display: inline-block;
    margin-bottom: 0;
    padding-top: 0;
    min-height: 20px;
    line-height: 20px;
    vertical-align: top
}

.multiselect .multiselect__select {
    height: 45px
}

.user_email_wrp .second-toolbar a {
    display: none !important
}

.user_email_wrp .fr-view table td,
.user_email_wrp .fr-view table th {
    border: none
}

.user_email_wrp .fr-view table th {
    background: none
}

.user_email_wrp .fr-wrapper>div:first-child {
    display: none !important
}

body.email_sent_popup {
    overflow-y: hidden
}

.multiselected .invalid-feedback {
    display: block
}

.user_email_wrp .ql-container.ql-snow {
    background: #fff !important
}

.unsubscribed_lable_field .invalid-feedback {
    display: block
}

.profile_update_wrp .user_filter_label .dropdown .form_control {
    padding: 0 25px 0 5px !important;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.1) !important;
    background-image: url(../assets/images/down_arrow.png);
    background-position: center right 4px;
    background-repeat: no-repeat;
    background-size: 12px;
    transition: all .7s cubic-bezier(0.42, 1.14, 1, 1);
    min-width: 121px;
    border-radius: 4px;
    font-size: 20px;
    color: #fff;
    line-height: 50px;
    height: 50px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;

    @media only screen and (max-width:767px) {
        line-height: 42px;
        height: 42px;
        font-size: 16px !important;
    }

}

.profile_update_wrp .user_filter_label .dropdown-menu .dropdown-menuin ul li {
    font-size: 20px
}

.member_list_filters_wrp .owl-theme .owl-dots .owl-dot span {
    width: 20px;
    height: 30px;
    background: none !important;
    outline: none !important;
    font-family: FontAwesome;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    font-size: 40px;
    line-height: 28px;
    color: #ffc107;
    border-radius: 0;
    text-align: center
}

.member_list_filters_wrp .owl-theme .owl-dots .owl-dot span::before {
    content: "\f104"
}

.member_list_filters_wrp .owl-theme .owl-dots .owl-dot:last-child span::before {
    content: "\f105"
}

.member_list_filters_wrp .owl-theme .owl-dots .owl-dot.active span {
    display: none !important
}

.member_list_filters_wrp .owl-theme .owl-dots .owl-dot:hover span {
    color: #87cefa
}

button:focus {
    outline: none !important
}

.member_list_filters_wrp .owl-carousel {
    position: relative
}

.member_list_filters_wrp .owl-carousel .owl-dots {
    position: absolute;
    top: 52px;
    margin: 0 !important;
    left: 0;
    right: 0
}

.member_list_filters_wrp .owl-carousel .owl-dots .owl-dot {
    position: absolute;
    left: -21px;
    right: auto;
    z-index: 100
}

.member_list_filters_wrp .owl-carousel .owl-dots .owl-dot:last-child {
    right: -21px;
    left: auto
}

.user_filter_label .dropdown .dropdown-menu {
    background: rgba(40, 40, 40, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.1)
}

.custom_select_dropdown .form_control {
    background-image: url(../assets/images/down_arrow.png);
    background-position: center right 5px;
    background-repeat: no-repeat;
    background-size: 12px;
    background-color: rgba(40, 40, 40, 0.8);
    -webkit-appearance: none;
    appearance: none;
    -moz-appearance: none;
    padding: 0 15px;
    outline: none;
    font-size: 20px;
    height: 50px;
    line-height: 50px;
    color: #fff;
    border-radius: .25rem
}

.custom_select_dropdown .dropdown-menu {
    height: 400px;
    overflow-y: auto;
    background: rgba(40, 40, 40, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.1)
}

.custom_select_dropdown .dropdown-menuin ul {
    margin: 0
}

.custom_select_dropdown .dropdown-menuin ul li {
    padding: 3px 5px;
    cursor: pointer;
    background: none !important;
    border: none !important;
    color: #ffc107;
    font-size: 18px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif
}

.custom_select_dropdown .dropdown-menuin ul li:hover,
.custom_select_dropdown .dropdown-menuin ul li.selected {
    background: #2b76ff !important;
    color: #fff
}

.custom_select_dropdown[aria-invalid="true"]+small.invalid-feedback {
    display: block !important
}

.custom_select_dropdown+small.invalid-feedback {
    display: none !important
}

.about_us_list_accordion.about_accordion_active .computer_popup_list {
    display: block
}

body.body_right_scroll_remove {
    overflow-y: hidden
}
.no-scroll{
    overflow-y: hidden !important
}

.create_meeting_popup .create_meeting_popup_body .vdatetime-input {
    height: auto;
    padding: 9px 15px;
    background: rgba(255, 255, 255, 0.1);
    border-color: transparent;
    font-size: 16px;
    color: #fff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    -webkit-transition: all .7s cubic-bezier(0.42, 1.14, 1, 1);
    transition: all .7s cubic-bezier(0.42, 1.14, 1, 1);
    border-radius: 4px;
    width: 100%
}

.create_meeting_popup .create_meeting_popup_body .mx-datepicker .mx-icon-calendar,
.create_meeting_popup .create_meeting_popup_body .mx-datepicker .mx-icon-clear {
    color: #fff
}

body .mx-datepicker-main {
    background: rgba(40, 40, 40, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #ffc107
}

body .mx-datepicker-main .mx-btn {
    color: #ffc107
}

body .mx-datepicker-main .mx-table-date .today {
    color: #87cefa
}

body .mx-datepicker-main .mx-calendar-content .cell.active,
body .mx-datepicker-main .mx-calendar-content .cell:hover {
    background: #87cefa;
    color: #333 !important
}

body .mx-datepicker-main .mx-table-date .cell.not-current-month {
    color: #97885a
}

.create_meeting_popup_body .multiselect__content-wrapper {
    background: rgba(40, 40, 40, 0.95);
    border-color: rgba(255, 255, 255, 0.1) !important;
    color: #ffc107
}

.create_meeting_popup_body .multiselect__content-wrapper .multiselect__option--highlight,
.create_meeting_popup_body .multiselect__option--highlight:after {
    background: #87cefa;
    color: #333 !important
}

.create_meeting_popup_body .multiselect__content-wrapper .multiselect__option--selected.multiselect__option--highlight {
    background: #ff6a6a;
    color: #fff
}

.create_meeting_popup_body .multiselect .multiselect__tags {
    padding: 12px 40px 0 15px
}


.user_email_body .multiselect .multiselect__tags {
    font-size: 20px;
    padding-left: 15px
}

.create_webinar_popup .create_webinar_popup_body .vdatetime-input {
    height: auto;
    padding: 9px 15px;
    background: rgba(255, 255, 255, 0.1);
    border-color: transparent;
    font-size: 16px;
    color: #fff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    -webkit-transition: all .7s cubic-bezier(0.42, 1.14, 1, 1);
    transition: all .7s cubic-bezier(0.42, 1.14, 1, 1);
    border-radius: 4px;
    width: 100%
}

.create_webinar_popup .create_webinar_popup_body .mx-datepicker .mx-icon-calendar,
.create_webinar_popup .create_webinar_popup_body .mx-datepicker .mx-icon-clear {
    color: #fff
}

.create_webinar_popup_body .multiselect__content-wrapper {
    background: rgba(40, 40, 40, 0.95);
    border-color: rgba(255, 255, 255, 0.1) !important;
    color: #ffc107
}

.create_webinar_popup_body .multiselect__content-wrapper .multiselect__option--highlight,
.create_webinar_popup_body .multiselect__option--highlight:after {
    background: #87cefa;
    color: #333 !important
}

.create_webinar_popup_body .multiselect__content-wrapper .multiselect__option--selected.multiselect__option--highlight {
    background: #ff6a6a;
    color: #fff
}

.create_webinar_popup_body .multiselect__single {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px !important;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #41b883 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle !important;
    width: auto
}

.multiselect .multiselect__placeholder {
    font-size: 18px
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0
}

input[type=number] {
    -moz-appearance: textfield
}

.quillWrapper .ql-snow.ql-toolbar {
    padding-top: 8px !important;
    padding-bottom: 4px !important;
    border: none !important;
    background: rgba(255, 255, 255, 0.1) !important;
    border: 0 !important;
    color: #fff !important;
    font-size: 14px !important;
    margin-bottom: 2px !important;
    border-radius: .25rem !important
}

.ql-container.ql-snow {
    border: none !important;
    background: rgba(255, 255, 255, 0.1) !important;
    border: 0 !important;
    color: #fff !important;
    font-size: 14px !important;
    border-radius: .25rem !important
}

.ql-snow .ql-fill,
.ql-snow .ql-stroke.ql-fill {
    fill: #fff !important
}

.quillWrapper .ql-snow .ql-stroke,
.ql-snow .ql-toolbar button svg,
.quillWrapper .ql-snow.ql-toolbar button svg {
    stroke: #fff !important
}

.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow .ql-toolbar button.ql-active .ql-stroke,
.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow .ql-toolbar button:focus .ql-stroke,
.ql-snow .ql-toolbar button:focus .ql-stroke-miter,
.ql-snow .ql-toolbar button:hover .ql-stroke,
.ql-snow .ql-toolbar button:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow.ql-toolbar button.ql-active .ql-stroke,
.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar button:focus .ql-stroke,
.ql-snow.ql-toolbar button:focus .ql-stroke-miter,
.ql-snow.ql-toolbar button:hover .ql-stroke,
.ql-snow.ql-toolbar button:hover .ql-stroke-miter {
    color: #fff !important
}

.ql-snow .ql-picker-options .ql-picker-item {
    outline: none !important
}

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,
.ql-snow.ql-toolbar .ql-picker-label.ql-active,
.ql-snow.ql-toolbar .ql-picker-label:hover,
.ql-snow.ql-toolbar .ql-picker-label {
    color: #fff !important;
    outline: none !important
}


.quillWrapper .ql-snow.ql-toolbar span.ql-formats:first-child {
    display: none !important
}

.quiz_option_content *,
.quiz_que_content * {
    margin: 0 !important;
    color: inherit;
    outline: none
}

.speaker_bio_details p,
.bio_more_data_popup_body p {
    font-size: 18px;
    line-height: 1.3;
    color: #d6d6d6;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
    margin-bottom: 15px;
    text-align: justify
}

.editor_bio_text p:last-child {
    margin-bottom: 0
}


.blog_content p {
    margin-bottom: 0;
    font-size: 16px;
    font-family: 'georgiaregular';
    text-align: left
}

.blog_content p:last-child {
    margin-bottom: 0
}

.blog_content {
    font-family: 'georgiaregular';
    font-size: 16px;
    letter-spacing: .72px;
    line-height: 1.3;
    color: #d6d6d6
}

.blog_content * {
    font-size: 16px;
    font-family: 'georgiaregular';
    letter-spacing: .72px;
    line-height: 1.3;
    margin-bottom: 0
}

.single_post_content {
    font-size: 20px;
    color: #d4d0ca;
    font-family: 'georgiaregular';
    letter-spacing: .72px;
    line-height: 1.58
}

.single_post_content * {
    font-size: 20px;
    letter-spacing: .72px;
    line-height: 1.58;
    font-weight: 400;
    margin-bottom: 0;
    color: #d4d0ca !important
}

.single_post_content a {
    color: #87cefa !important
}

.single_post_content p {
    color: #d4d0ca;
    font-family: 'georgiaregular';
    margin-bottom: 0;
    text-align: left;
    overflow-wrap: break-word
}

.single_post_content p * {
    color: #d4d0ca !important
}

.single_post_content p a {
    color: #87cefa !important
}

.single_post_content p img {
    max-width: 100%
}

.update_blogs_form_inner .custom_select_dropdown .form_control,
.create_blogs_form_inner .custom_select_dropdown .form_control {
    height: 40px;
    line-height: 40px;
    font-size: 16px
}

.single_post_socail_share ul li span {
    cursor: pointer
}

.create_blogs_form_inner .invalid-feedback,
.update_blogs_form_inner .invalid-feedback {
    font-size: 14px
}

.single_post_content ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    padding-inline-start: 40px
}

.single_post_socail_share ul li svg {
    width: 30px;
    height: 30px
}

.blog_detail_right_section .blog_content * {
    line-height: 1.3;
    font-size: 18px
}

.normal_user_support_chat_popup .msg_time {
    color: silver;
    display: block
}

.support_chat_reply_page_wrp .msg_time {
    color: silver
}

.opacity-0,
.opacity_0 {
    opacity: 0 !important
}

.video_conference_page .dashboard_left_sidebar_main_wrp,
.video_conference_page .support_chat {
    display: none !important
}

.global_filter_name_in_html p {
    margin: 0 !important;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.1
}

.member_list_filters_wrp .global_filter_name_in_html p:nth-child(3) {
    margin-bottom: -10px !important
}

.drag_item_box {
    display: contents
}

.single_post_content p.ql-align-center {
    text-align: center
}

.single_post_content p.ql-align-center img {
    margin: 5px 0
}

.message_sender_name {
    display: block;
    margin-top: -1px;
    font-size: 14px;
    color: #7e009a;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    font-weight: 600;
    letter-spacing: .5px;
    margin-bottom: 2px
}

.create_group_team_popup_wrp .multiselect__content-wrapper {
    background: rgba(40, 40, 40, 0.95);
    border-color: rgba(255, 255, 255, 0.1) !important;
    color: #ffc107
}

.create_group_team_popup_wrp .multiselect__content-wrapper .multiselect__option--highlight,
.create_group_team_popup_wrp .multiselect__option--highlight:after {
    background: #87cefa;
    color: #333 !important
}

.create_group_team_popup_wrp .multiselect__content-wrapper .multiselect__option--selected.multiselect__option--highlight {
    background: #ff6a6a;
    color: #fff
}

.left_sidebaar_disabled_for_page .dashboard_wrp {
    padding-left: 10px !important;
    padding-top: 0 !important
}

.left_sidebaar_disabled_for_page .dashboard_left_sidebar_main_wrp {
    display: none !important
}

.left_sidebaar_disabled_for_page.contact_us_page_wrp .wrapper {
    background: url(../assets/images/contact_us.jpg) no-repeat #000 !important;
    background-size: cover !important;
    background-attachment: fixed !important
}

.multiselect_dropdown_ui .multiselect__content-wrapper {
    background: rgba(40, 40, 40, 0.95);
    border-color: rgba(255, 255, 255, 0.1) !important;
    color: #ffc107
}

.multiselect_dropdown_ui .multiselect__content-wrapper .multiselect__option--highlight,
.multiselect_dropdown_ui .multiselect__option--highlight:after {
    background: #87cefa;
    color: #333 !important
}

.multiselect_dropdown_ui .multiselect__content-wrapper .multiselect__option--selected.multiselect__option--highlight {
    background: #ff6a6a;
    color: #fff
}

.bio_text_read_more {
    padding-left: 10px;
    padding-right: 10px
}

.bio_text_read_more .editor_bio_text * {
    color: #d6d6d6 !important
}

.bio_text_read_more .editor_bio_text ul {
    list-style-type: disc;
    padding-inline-start: 20px
}

.bio_more_data_popup .bio_more_data_popup_body {
    max-height: 90vh;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 5px;
        background: #000
    }
    &::-webkit-scrollbar-thumb {
        background-color: #232323;
        border-radius: 10px
    }
    * {
        color: #fff !important;
        font-size: 18px
    }
    ul {
        display: block;
        list-style-type: disc;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0;
        margin-inline-end: 0;
        padding-inline-start: 40px
    }

}

.notes_converted_pdf_preview_body .header_fix {
    z-index: 99
}

.create_data_popup .user_acknowledgement_popup .modal-backdrop {
    opacity: 0 !important
}


.update_about_of_user_prfl_popup .multiselect .multiselect__tags {
    padding: 10px 40px 0 15px;
    min-height: 40px
}

.update_about_of_user_prfl_popup .multiselect .multiselect__select {
    height: 40px;
    display: none !important
}
@media screen and (max-width: 1280px) and (max-height: 580px) {

    .create_blogs_form_inner .custom_select_dropdown .dropdown-menu,
    .update_blogs_form_inner .custom_select_dropdown .dropdown-menu {
        height: 300px
    }
}

.note_for_textarea_styling .readonly_html_note_text {
    font-size: 18px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    letter-spacing: 1px;
    font-weight: 600;
    color: #000;
    height: calc(100dvh - 325px);
    overflow-y: auto;
    padding-top: 5px;
}

.note_for_textarea_styling .readonly_html_note_text * {
    color: #ffffff;
    margin: 0
}

.note_for_textarea_styling .readonly_html_note_text::-webkit-scrollbar {
    width: 5px;
    background: none
}

.note_for_textarea_styling .readonly_html_note_text::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.18)
}

.note_for_textarea_styling .ql-editor {
    padding: 10px 0;
    font-size: 18px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    // letter-spacing: 1px;
    font-weight: 400;
    height: calc(100dvh - 310px);
    line-height: 1.25;
}

.note_for_textarea_styling .ql-editor::-webkit-scrollbar {
    width: 5px;
    background: none
}

.note_for_textarea_styling .ql-editor::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.18)
}

.note_for_textarea_styling .ql-editor strong {
    font-weight: 600
}

.note_for_textarea_styling .quillWrapper .ql-container.ql-snow {
    background: none !important;
    color: #000 !important
}

.no_write_access_notes .note_for_textarea_styling .readonly_html_note_text {
    height: calc(100dvh - 280px)
}

.notes_list_items li span.note_html_title * {
    margin: 0 !important
}

.ql-editor.ql-blank::before {
    font-style: normal !important;
    left: 0 !important;
    color: rgba(0, 0, 0, 0.3) !important
}

.lymhpomap_recent_conference_wrp .header_menu {
    display: none
}

.conference_countdown_home .container {
    padding: 5px 0 0
}

.conference_countdown_home .flip-card {
    font-size: 22px !important
}

.conference_countdown_home .flip-clock__slot {
    font-size: 14px !important;
    color: #ff8d00;
    font-weight: 500
}

.conference_countdown_home .flip-card__bottom,
.conference_countdown_home .flip-card__back-bottom,
.conference_countdown_home .flip-card__bottom-4digits,
.conference_countdown_home .flip-card__back-bottom-4digits {
    border-top: 0 !important
}

.conference_info_inner:hover .flip-clock__slot {
    color: #000 !important
}

.notes_view_content * {
    margin: 0 !important
}

.vdatetime-popup {
    box-shadow: 0 1px 3px 0 rgba(137, 135, 135, 0.3) !important;
    color: #fff !important;
    background: #000 !important
}

.vdatetime-popup .vdatetime-popup__header {
    background: #87cefa;
    color: #000
}

.vdatetime-popup .vdatetime-calendar__month__day--selected>span>span,
.vdatetime-popup .vdatetime-calendar__month__day--selected:hover>span>span,
.vdatetime-popup .vdatetime-calendar__month__day:hover>span>span {
    color: #000;
    background: #87cefa
}

.vdatetime-popup .vdatetime-popup__actions__button {
    color: #87cefa
}

.vdatetime-popup .vdatetime-popup__actions__button:hover {
    color: #fff
}

.vdatetime-popup .vdatetime-time-picker__item--selected {
    color: #87cefa
}

.vdatetime-popup .vdatetime-time-picker__with-suffix .vdatetime-time-picker__list.vdatetime-time-picker__list--suffix {
    overflow-y: hidden
}

.pdf_note_editor_wrp .ql-toolbar {
    display: none
}

.pdf_note_editor_wrp .ql-editor.ql-blank::before {
    font-style: normal !important;
    left: 15px !important;
    color: rgba(255, 255, 255, 0.3) !important
}

.pdf_note_editor_wrp .ql-editor ul {
    padding-left: 0
}

.pdf_note_editor_wrp .ql-container {
    max-height: calc(100dvh - 250px);
    overflow-y: auto
}

.pdf_note_editor_wrp .ql-container::-webkit-scrollbar {
    width: 5px;
    background: #000
}

.pdf_note_editor_wrp .ql-container::-webkit-scrollbar-thumb {
    background-color: #232323;
    border-radius: 10px
}

.notes_view_for_wrp .note_view_list_wrp .note_view_list_data * {
    margin: 0
}


.upload_paper_popup .update_paperpile_info_popup {
    background: none !important
}

li.bucket_folder_list_item.sub_folder_dd.show_sub_bucket:before {
    content: "";
    border-left: 1px dashed #111;
    height: 100%;
    position: absolute;
    left: 4px;
    top: 1px
}


.our_team_member_info_para_wrp p {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
    font-size: 18px;
    color: #fff;
    margin-bottom: 10px;
    backface-visibility: hidden;
    line-height: 24px
}

.patient_with_chat_box .append_pchatmsg {
    width: 100%;
    padding: 5px 0
}

.patient_with_chat_box .pchatmsg_recieved {
    text-align: right
}

.patient_with_chat_box .pchat_msg_item {
    position: relative;
    display: inline-block;
    padding: 5px 10px;
    word-break: break-word;
    white-space: normal;
    font-weight: 500
}

.patient_with_chat_box .pchat_msg_item:after {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    border-style: solid
}

.patient_with_chat_box .pchat_msg_item.pchat_recieved_msg {
    background: #ffb6c1;
    color: #000;
    border-radius: 7px 0 7px 7px;
    text-align: left
}

.patient_with_chat_box .pchat_msg_item.pchat_recieved_msg:after {
    border-width: 0 0 8px 6px;
    border-color: transparent transparent transparent #ffb6c1;
    top: 0;
    right: -6px
}

.patient_with_chat_box .pchat_msg_item.pchat_send_msg {
    background: #b1d4e5;
    color: #000;
    border-radius: 0 7px 7px 7px
}

.patient_with_chat_box .pchat_msg_item.pchat_send_msg:after {
    border-width: 0 6px 8px 0;
    border-color: transparent #b1d4e5 transparent transparent;
    top: 0;
    left: -6px
}

.private_vista_media_info_wrp .video_author_details_inner p {
    margin-bottom: 8px
}

.private_vista_media_info_wrp .video_author_details_inner p:last-child {
    margin-bottom: 0
}

.private_vista_media_info_wrp .video_author_details_inner p a {
    color: #87cefa;
    text-decoration: none
}

.private_vista_media_info_wrp .video_author_details_inner p a:hover {
    color: #ffd400
}

.model_details_val * {
    margin: 0 0 3px !important
}

.model_details_val br {
    display: none !important
}

.vdatetime-input {
    height: auto;
    padding: 9px 15px;
    background: rgba(255, 255, 255, 0.1);
    border-color: transparent;
    font-size: 16px;
    color: #fff;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    -webkit-transition: all .7s cubic-bezier(0.42, 1.14, 1, 1);
    transition: all .7s cubic-bezier(0.42, 1.14, 1, 1);
    border-radius: 4px;
    width: 100%
}

.multiselect--disabled .multiselect__current,
.multiselect--disabled .multiselect__select,
.multiselect--disabled {
    background: none !important;
    opacity: 1 !important;
    cursor: not-allowed !important;
    pointer-events: visible !important
}

.lbil_launched_conference_wrp header {
    display: none
}

.sinup_of_lymphomap_service_popup_body .multiselect__input,
.sinup_of_lymphomap_service_popup_body .multiselect__single {
    line-height: 26px
}

.gray_out_global_btn {
    background: #6c757d !important;
    color: #fff !important;
    min-width: 95px;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    outline: none !important;
    border: none !important;
    border-radius: 3px !important;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    font-size: 18px !important;
    opacity: .9
}

.signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__tags {
    border: 0;
    background: rgba(255, 255, 255, 0.08) !important;
    padding: 0 20px;
    min-height: 52px;
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.1)
}

.signup_fields_multiselect .multiselect_dropdown_ui .multiselect.multiselect--active .multiselect__tags {
    border: 1px solid #ffd400
}

.signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__single,
.signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__input {
    font-size: 18px;
    line-height: 52px;
    color: #ffd400
}

.signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__single::placeholder,
.signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__input::placeholder,
.signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__single::-webkit-input-placeholder,
.signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__input::-webkit-input-placeholder,
.signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__single::-moz-placeholder,
.signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__input::-moz-placeholder {
    color: rgba(255, 255, 255, 0.3) !important
}

.signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__placeholder {
    color: rgba(255, 255, 255, 0.3);
    font-size: 18px;
    line-height: 52px
}

.signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__content-wrapper {
    overflow-x: hidden
}

.signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__select {
    height: 52px
}

@media only screen and (max-width: 1023px) {
    .header_fix {
        background: #000 !important
    }

    .license_country_list_wrp {
        margin-bottom: 15px
    }

    .public_vista_btn,
    .cancer_classification_btn,
    .lymphomap_computer_btn,
    .lymphomap_ab_btn {
        z-index: 100 !important
    }

    .signup_page_wrp .signup_form_main {
        padding-top: 40px
    }
}

.our_app_slider_inner .owl-carousel {
    border-radius: 35px
}

.our_app_slider_inner .owl-carousel .owl-stage-outer,
.our_app_slider_inner .owl-carousel .owl-stage,
.our_app_slider_inner .owl-carousel .owl-item,
.our_app_slider_inner .owl-carousel .carousel_item {
    border-radius: 35px;
    background: #000
}

.our_app_slider_inner>div>span {
    display: block !important
}


.profile_update_wrp .custom_select_dropdown .form_control {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.08);
    color: #ffd400
}

@media only screen and (max-width: 1023px) {
    .profile_update_wrp .custom_select_dropdown .form_control {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 18px
    }
}

@media only screen and (max-width: 1023px) {
    .profile_update_wrp .custom_select_dropdown .dropdown-menu {
        width: 100%
    }
}

.profile_update_wrp .custom_select_dropdown.show .form_control {
    border: 1px solid #ffd400
}

.profile_update_wrp .user_filter_label .dropdown .form_control {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.08);
    color: #ffd400;
    padding: 0 25px 0 20px !important
}

@media only screen and (max-width: 1023px) {
    .profile_update_wrp .user_filter_label .dropdown .form_control {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 18px
    }
}

.profile_update_wrp .user_filter_label .dropdown.show .form_control {
    border: 1px solid #ffd400
}


.request_for_demo_section_body .vdatetime-input {
    width: 100%;
    height: 44px;
    font-weight: 400;
    font-size: 16px;
    border-radius: 5px;
    padding: 0 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: none;
    outline: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    color: #ffd400;
    background: rgba(255, 255, 255, 0.08)
}

.request_for_demo_section_body .col-sm-6,
.request_for_demo_section_body .col-sm-12 {
    position: static !important
}

.request_for_demo_section_body .signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__tags {
    min-height: 44px;
    z-index: 1;
    position: relative
}

.request_for_demo_section_body .signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__single,
.request_for_demo_section_body .signup_fields_multiselect .multiselect_dropdown_ui .multiselect .multiselect__input {
    line-height: 44px;
    font-size: 16px;
    z-index: -1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
}

.unauthorized_req_demo_main .vdatetime-overlay,
.unauthorized_req_demo_main .vdatetime-popup {
    position: absolute !important;
    right: 0;
    top: 0;
    width: 100% !important;
    min-width: 100% !important
}

.lymphomap_main {
    position: relative
}

@media only screen and (min-width:767px){
.signup_page_wrp {
    overflow-y: hidden !important
}
}
@media only screen and (max-width:767px){
.signup_page_wrp {
   .bg_banners_slider{
    position: fixed !important;
    inset: 0;
   }
}
}
.signup_page_wrp .header_fix {
    background: none;
    z-index: 100000
}

.login_body {
    overflow-y: scroll;

    .header_fix {
        background: none;
        width: calc(100% - 65px);

        @media only screen and (max-width: 767px) {
            width: 100%
        }
    }
}

.login_body::-webkit-scrollbar {
    width: 5px;
    background: #000 16px
}

.login_body::-moz-scrollbar {
    width: 5px;
    background: #000 16px
}

.login_body::-webkit-scrollbar-thumb {
    background-color: #232323
}

.login_body::-moz-scrollbar-thumb {
    background-color: #232323
}

.login_body.covid_19_popup_actv .request_for_demo_section_main {
    opacity: 0 !important
}

.login_body.registration_form {
    overflow-y: hidden !important
}

.login_body.registration_form .sign_up_form_scrollbar::-webkit-scrollbar {
    width: 5px;
    background: #000 16px
}

.login_body.registration_form .sign_up_form_scrollbar::-moz-scrollbar {
    width: 5px;
    background: #000 16px
}

.login_body.registration_form .sign_up_form_scrollbar::-webkit-scrollbar-thumb {
    background-color: #232323
}

.login_body.registration_form .sign_up_form_scrollbar::-moz-scrollbar-thumb {
    background-color: #232323
}

.login_body.registration_form .cancer_classification_btn,
.login_body.registration_form .lymphomap_ab_btn,
.login_body.registration_form .lymphomap_computer_btn,
.login_body.registration_form .public_vista_btn {
    right: 25px
}

.mem_usr_about_me_info div {
    font-family: 'MyriadProRegular', 'Lato', sans-serif
}

.mem_usr_about_me_info p {
    font-size: 15px;
    text-align: justify;
    margin: 0
}

.mem_usr_about_me_info p strong {
    font-weight: bolder
}

@media only screen and (max-width: 1023px) {
    .full_section_in_mbl .fa-times-circle-o {
        display: none !important
    }

    .full_section_in_mbl .fa-times-circle-o.mbl_cross {
        display: block !important
    }

    .full_section_in_mbl .request_for_demo_label_fixed {
        left: 0 !important;
        right: 0;
        margin: 0 auto;
        border-radius: 70px !important;
        width: 205px !important;
        top: 80% !important;
        position: static !important;
        margin-top: 25px
    }


    .lbil_linkage_popup.ab_main_popup .light_bg_popup {
        height: auto
    }

    .lbil_linkage_popup.ab_main_popup .computer_popup_heading {
        font-size: 32px !important;
        margin-bottom: 10px !important
    }

    .lbil_linkage_popup.ab_main_popup p {
        font-size: 18px
    }

    .lbil_linkage_popup.ab_main_popup .lbil_logo {
        margin-bottom: 10px !important
    }

    .lbil_linkage_popup.ab_main_popup .lbil_logo img {
        width: 80px
    }

    .lbil_linkage_popup.ab_main_popup .btn-primary {
        margin-top: 10px !important
    }

    .launched_conference_wrp .blurb_of_lbil_lunched_popup .btn .container {
        padding: 0 8px
    }

    .launched_conference_wrp .blurb_of_lbil_lunched_popup .btn .container .flip-card {
        font-size: 28px
    }
}

.notes_pdf_body_wrp a {
    display: inline;
    color: #0563c1;
    box-sizing: border-box;
    text-decoration: underline
}

.notes_pdf_body_wrp span {
    display: inline-block;
    line-height: 1.25
}

.e-dialog.e-quick-dialog {
    width: 380px !important
}

.e-dialog.e-quick-dialog .e-dlg-header {
    color: #ffd400 !important
}

.e-dialog.e-quick-dialog .e-dlg-content {
    color: #fff !important
}

@media only screen and (max-width: 355px) {
    .e-dialog.e-quick-dialog {
        width: 100% !important
    }
}

.e-schedule .e-more-indicator {
    color: #ffd400 !important
}

.e-repeat-parent-row {
    display: none !important
}


@media only screen and (max-width: 767px) {
    .payment_checkout_info .appointment_detail_heading {
        font-size: 20px !important
    }

    .payment_checkout_info .appointment_info_wrp {
        padding: 10px !important
    }

    .payment_checkout_info .cancellation_fees_blurb .packages_heading {
        font-size: 24px !important
    }

    .payment_checkout_info .cancellation_fees_blurb .packages_subheading {
        font-size: 22px !important
    }

    .payment_checkout_info .cancellation_fees_blurb .packages_features_list li {
        font-size: 18px !important
    }
}

@media only screen and (max-width: 767px) {

    .models_list_wrp thead,
    .table_algo_data thead,
    .payment_history_list thead {
        display: none
    }

    .models_list_wrp tbody,
    .table_algo_data tbody,
    .payment_history_list tbody {
        display: block
    }

    .models_list_wrp tbody>tr,
    .table_algo_data tbody>tr,
    .payment_history_list tbody>tr {
        display: block;
        background: rgba(228, 233, 237, 0.1);
        margin-bottom: 1px;
        padding: 10px 0
    }

    .models_list_wrp tbody>tr>td,
    .table_algo_data tbody>tr>td,
    .payment_history_list tbody>tr>td {
        display: block;
        text-align: left !important;
        height: auto !important;
        padding: 8px 10px !important;
        background: none !important
    }
}

.about_lbil_third_section .ab_us_accordion_content .ab_us_accordion_title_wrp {
    cursor: unset !important
}

.theme_multiselected_styled .multiselect .multiselect__tags {
    padding: 12px 40px 12px 15px;
    min-height: initial;
    border: 1px solid rgba(255, 255, 255, 0.1)
}

.theme_multiselected_styled .multiselect .multiselect__tags .multiselect__tag {
    margin-bottom: 0
}

.theme_multiselected_styled .multiselect.multiselect--active .multiselect__tags {
    border-color: #ffd400
}

body.researchfile_body_wrp.pdf_view_actv {
    overflow-y: hidden
}

#pdf-annotate-text-input {
    font-family: 'MyriadProRegular', 'Lato', sans-serif
}

.custom_ui_of_datetim_field .vdatetime-input {
    padding: 12px 15px !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    color: #ffd400 !important
}

@media only screen and (max-width: 767px) {
    .rfiles_list_title h3 {
        font-size: 18px !important
    }

    .create_researchg_popup_modal {
        height: 100dvh;
        overflow-y: auto
    }

    .create_researchg_popup_modal .multiselect__tag {
        word-wrap: break-word;
        white-space: normal
    }

    .paperpile_content_list_wrp.mt-5 {
        margin-top: 15px !important
    }
}

.notifiaction_title p {
    margin: 0;
    line-height: inherit
}


.e-quick-popup-wrapper .e-popup-footer .e-event-details {
    font-size: 0;
    position: relative;
    padding: 0;
    width: 26px;
    height: 46px;
    line-height: 46px;
    margin-right: 15px !important
}

.e-quick-popup-wrapper .e-popup-footer .e-event-details:before {
    content: "\f040";
    font-family: 'FontAwesome';
    font-size: 24px;
    color: #ffd400
}

.e-quick-popup-wrapper .e-popup-footer .e-event-details:hover {
    background: none
}

.e-quick-popup-wrapper .e-popup-footer .e-event-details:hover:before {
    color: #87cefa
}

.e-quick-popup-wrapper .e-popup-footer .e-event-create {
    background: rgba(255, 255, 255, 0.12) !important;
    color: #ffd400 !important;
    margin-right: 15px
}

.e-quick-popup-wrapper .e-popup-footer .e-event-create:hover {
    background: #87cefa !important;
    color: #22292f !important
}
.event_gallery_box .blueimp-gallery {
    background: rgba(0, 0, 0, 0.92)
}

.event_gallery_box .blueimp-gallery>.next,
.event_gallery_box .blueimp-gallery>.prev {
    color: #ffc107;
    border: 2px solid #ffc107;
    text-shadow: 0 0 2px #ffc107;
    font-size: 46px;
    line-height: 32px
}

.event_gallery_box .blueimp-gallery>.close:hover,
.event_gallery_box .blueimp-gallery>.next:hover,
.event_gallery_box .blueimp-gallery>.play-pause:hover,
.event_gallery_box .blueimp-gallery>.prev:hover,
.event_gallery_box .blueimp-gallery>.title:hover {
    color: #ffc107;
    opacity: 1
}

.event_gallery_box .blueimp-gallery>.close {
    font-size: 40px;
    color: #e4002b;
    opacity: 1
}

.event_gallery_box .blueimp-gallery>.close:hover {
    color: #ffd400
}

.event_content_wrp p {
    font-size: 18px;
    margin-bottom: 10px;
    line-height: 1.3;
    color: #fffcc4
}

.rsg_des {
    color: #c8c3af;
    font-size: 16px;
    line-height: 1.4
}

.rsg_des * {
    margin: 0
}

.rsg_des ul {
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0;
    margin-inline-end: 0;
    padding-inline-start: 40px
}

.shared_popup_wrp .multiselect .multiselect__tags {
    padding: 12px 40px 5px 15px
}

.blurb_f_predication {
    p {
        font-size: 16px;
        color: #d9d8d4;
        text-align: justify;
        line-height: 1.3;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
        margin-bottom: 10px;

        span {
            font-weight: bold;
        }
    }
}


.blurb_batch_file {
    p {
        font-size: 16px;
        color: #ffffff;
        text-align: justify;
        line-height: 1.3;
        font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
        margin-bottom: 10px;

        a {
            color: #87cefa;

            &:hover {
                color: #ffca00;
            }
        }
    }
}

.popup_open_body {

    .request_for_demo_label_fixed,
    .covid_19_popup {
        z-index: 10 !important;
    }
}

.body_right_scroll_remove .some_details_of_group_wrp {
    z-index: inherit !important;
}

.media_video_slider .owl-stage-outer {
    padding: 5px 0px;
}

.custom_datetime_picker {
    .vpd-main {
        display: block;
        border-radius: 5px;
        padding: 0px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        outline: none !important;
        box-shadow: none !important;
        background: rgba(255, 255, 255, 0.08);
        height: 44px;
        line-height: 44px;

        .vpd-month-label {
            width: 110px !important;

            &>span {
                padding: 0px;
            }
        }

        .vpd-year-label {
            height: auto;

            &>span {
                padding: 0x;
            }
        }

        .vpd-icon-btn {
            background: none !important;
            line-height: 1;
            padding-right: 0px;

            svg {
                fill: rgba(255, 255, 255, 0.35);
            }
        }

        .vpd-input-group input {
            background: none;
            border: none;
            color: #ffd400;
        }

        .vpd-wrapper {
            position: absolute;
            font-size: 14px;

            .vpd-header {
                background: #87cefa !important;
                color: #000000;
            }

            .vpd-body {
                box-shadow: 0 1px 3px 0 rgba(137, 135, 135, .3) !important;
                color: #ffffff !important;
                background: #000000 !important;
            }
        }

        .vpd-day[disabled] .vpd-day-text {
            color: #4e4d48;
        }

        .vpd-controls button svg path {
            fill: #fff;
        }
    }

    &.active {
        .vpd-icon-btn svg {
            fill: #ffd400 !important;
        }
    }
}

.todo_tab_content_wrp {
    .quillWrapper .ql-snow .ql-stroke, .ql-snow .ql-toolbar button svg, .quillWrapper .ql-snow.ql-toolbar button svg{
        stroke: #94a3b8 !important;
    }

    .ql-snow .ql-fill, .ql-snow .ql-stroke.ql-fill{fill: #94a3b8 !important;}

    .ql-snow.ql-toolbar .ql-picker-label{color: #94a3b8 !important;}

    .quillWrapper .ql-snow.ql-toolbar span.ql-formats:first-child {
        display: inline-block !important;
        margin: 0px !important;
    }

    .quillWrapper .ql-toolbar.ql-snow button:hover{
        background: rgba(255, 255, 255, 0.09) !important;
        svg, .ql-stroke{
            stroke: #ffffff !important;
        }
       .ql-fill{fill: #ffffff !important;}
       .ql-picker-label{color: #ffffff !important;}
    }

    .quillWrapper .ql-toolbar.ql-snow .ql-picker .ql-picker-label:hover{
        background: rgba(255, 255, 255, 0.09) !important;
        color: #ffffff !important;
        svg, .ql-stroke{
            stroke: #ffffff !important;
        }
       .ql-fill{fill: #ffffff !important;}
       .ql-picker-label{color: #ffffff !important;}
    }

    .ql-picker:not(.ql-background){top: 0px !important;}

    .ql-snow .ql-picker.ql-font {
        width: 95px;
    }


    /* Font whitelist for Quill */
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=arial]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=arial]::before {
        content: 'Arial' !important;
        font-family: Arial, sans-serif !important;
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=georgia]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=georgia]::before {
        content: 'Georgia' !important;
        font-family: Georgia, serif !important;
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=tahoma]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=tahoma]::before {
        content: 'Tahoma' !important;
        font-family: Tahoma, sans-serif !important;
    }


    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=verdana]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=verdana]::before {
        content: 'Verdana' !important;
        font-family: Verdana, sans-serif !important;
    }

    /* Apply fonts in editor content */
    .ql-font-arial {
        font-family: Arial, sans-serif;
    }

    .ql-font-georgia {
        font-family: Georgia, serif;
    }

    .ql-font-tahoma {
        font-family: Tahoma, sans-serif;
    }

    .ql-font-verdana {
        font-family: Verdana, sans-serif;
    }
}

@media only screen and (max-width:767px) {
    .login_body .footer_wrp.d-none {
        display: block !important;

    }

    .home_rdrtc_cross {
        padding: 2px 5px !important;
        font-size: 18px !important;
    }

    .single_post_content * {
        font-size: 16px;
    }

    .single_post_socail_share ul li svg {
        width: 20px;
        height: 20px;
    }
}

.btn:not(:disabled):not(.disabled):active:focus, .btn {
    box-shadow: none !important;
}
</style>